import EditorMenuService from 'live/services/editor-menu'
import EditorService from 'live/services/editor'

import { editorBuilder } from '../editor'
import React from 'react'
import widgetsService from 'live/services/widgets'
import Configs from '../editor/Configs'

export function addWidgetEditorToMenu(menuOptionInfo: {
    order: number
    type: string
    label: string
    description: string
    iconClass?: string
    thumbnail?: string
}): void {
    try {
        EditorMenuService.add({
            order: menuOptionInfo.order,
            type: menuOptionInfo.type,
            description: menuOptionInfo.description,
            label: menuOptionInfo.label,
            thumbnail: menuOptionInfo.thumbnail
        })
    } catch (err) {
        // supressing runtime error
        console.warn('New widget menu config requires live@2.28, falling back to old config mechanism')
        EditorService.newEditorMenuOption(menuOptionInfo.type, {
            order: menuOptionInfo.order,
            type: menuOptionInfo.type,
            label: menuOptionInfo.label,
            description: menuOptionInfo.description,
            thumbnail: menuOptionInfo.thumbnail
        })
    }
}

interface editorProps {
    type: string
    order: number
    label: string
    description: string
    iconClass?: string
    thumbnail?: string
}

export function addNewEditor({ type, ...props }: editorProps, tabs = []): void {
    const editorType = `${type}-chart-editor`
    EditorService.newEditor({
        name: editorType,
        editor: editorBuilder(type, tabs),
        defaultWidgetType: type
    })

    widgetsService.editor(type, editorType)
    widgetsService.ui(type, { editor: editorType })

    addWidgetEditorToMenu({
        type: editorType,
        ...props
    })
    widgetsService.dashboardActions(type, 'view', dashboardActionsProps => (
        <Configs type={type} isEditor={false} tabs={tabs} {...dashboardActionsProps} />
    ))
}
